"use client";

import React from "react";
import Link from "next/link";
import { BadgeCheck, User, Calendar, ShieldCheck, Mail } from "lucide-react";

interface AuthorBioProps {
  authorName: string;
}

export function AuthorBio({ authorName }: AuthorBioProps) {
  if (authorName !== "Mauricio L.") {
    return null;
  }

  return (
    <div className="w-full mt-12 p-6 sm:p-8 rounded-2xl border border-[var(--border)] bg-[var(--surface-muted)] flex flex-col sm:flex-row gap-6 items-start text-left">
      {/* Avatar Container */}
      <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-slate-200 dark:bg-zinc-800 flex items-center justify-center text-slate-500 dark:text-zinc-400 border border-[var(--border)] shrink-0 shadow-inner">
        <User size={36} className="stroke-[1.5]" />
      </div>

      {/* Bio Details */}
      <div className="flex-1 flex flex-col gap-3 font-sans">
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <h4 className="text-lg font-bold text-[var(--ink)] m-0 leading-none">
            {authorName}
          </h4>
          <span className="text-[10px] font-mono font-bold tracking-wider text-[var(--accent)] uppercase select-none">
            // Creator of Meazora
          </span>
        </div>

        <p className="text-xs sm:text-[13px] text-[var(--ink-soft)] leading-relaxed m-0 font-medium font-sans">
          Mauricio L. is a software developer who loves working with his hands. He built Meazora because he was tired of online calculators that exist just to capture your email and phone number. Every calculator here runs completely in your browser to keep your planning private, fast, and simple.
        </p>

        {/* Credentials / Trust Indicators */}
        <div className="flex flex-wrap gap-x-4 gap-y-2 mt-2 pt-3 border-t border-dashed border-[var(--line)] text-[10px] font-mono uppercase tracking-wider text-[var(--ink-faint)]">
          <div className="flex items-center gap-1.5">
            <ShieldCheck size={13} className="text-sky-600 dark:text-sky-400 shrink-0" />
            <span>Systems Engineer</span>
          </div>
          <div className="flex items-center gap-1.5">
            <Calendar size={13} className="text-[var(--accent)] shrink-0" />
            <span>DIY &amp; Remodeling Enthusiast</span>
          </div>
          <div className="flex items-center gap-1.5">
            <Link href="/authors/mauricio-l/" className="text-[var(--accent)] font-bold hover:underline flex items-center gap-1">
              Full Profile &amp; Story &rarr;
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
